import React from 'react';
import { Box } from '@chakra-ui/react';
import TablaExpedientes from './TablaExpedientes';

const Expedientes: React.FC = () => (
  <Box px={{ base: 2, md: 4 }} pt={79} pb={4}>
    <TablaExpedientes />
  </Box>
);

export default Expedientes;
